import { TargetPay } from "../../../dispatch/src/TargetPay";
import { Button, DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMovementCarrierPay extends Layout {
    buttonOverrideMaxPay: Button;
    buttonOverrideTargetPay: Button;
    layoutTargetPay: TargetPay;
    panelBuyToMarket: Panel;
    panelCarrierPayCalc: Panel;
    panelManifestMovementCharges: Panel;
    panelMaxAmt: Panel;
    panelMaxPay: Panel;
    panelOrderCharges: Panel;
    panelTargetPay: Panel;
    sourceMovement: DataSource;
    switchBtmExclude: Switch;
    textboxFreightCharge: Textbox;
    textboxManifestFreightCharge: Textbox;
    textboxManifestTotalCharge: Textbox;
    textboxManifestTotalOtherCharges: Textbox;
    textboxMaxPayCalc: Textbox;
    textboxMaxPayMargin: Textbox;
    textboxMaxPayMarginAmt: Textbox;
    textboxTargetMargin: Textbox;
    textboxTargetMarginAmt: Textbox;
    textboxTotalCharge: Textbox;
    textboxTotalOtherCharges: Textbox;
}
